
import { Component, Vue } from 'vue-property-decorator'
import { NewsService, BugService } from '@/services/index'
import { INewsData } from '@/types/news-types'
import BugDialog from './components/bugDialog.vue'
import PlatformTable from './components/platformTable.vue'
import EditRemarks from '@/components/bug/edit_remarks/index.vue'
import { NIUMEI_HOST, NIUMEI_TEST_HOST } from '@/config/env'
import { recommendNews } from './list.vue'
import { UserService } from '@/services'

@Component({
    name: 'NewsDetail',
    components: {
        BugDialog,
        PlatformTable,
        EditRemarks
    }
})
export default class extends Vue {
    private reprintType: any = {
        unReprint: 0,   // 非转载
        reprinted: 1,   // 被转载
        reprint: 2      // 转载他处
    }
    private statusMap: any = {
        toFixed: 0,   // 待优化
        perfect: 1   // 没问题
    }
    private bugStatusMap: any = {
        toFix: 1  // 待解决
    }
    private bugTypeOptions = [
        { key: 0, value: '所有类型' },
        { key: 1, value: '记者名抽取错误' },
        { key: 2, value: '漏抽记者名' },
        { key: 3, value: '分类问题' },
        { key: 4, value: '文章排版问题' },
        { key: 5, value: '标签抽取问题' },
        { key: 6, value: '转载识别问题' }
    ]
    private newsId: number = 0
    private news = {
        media: {},
        content: '',
        tags: '',
        reprint: {},
        is_deleted: false
    }
    private deletedNewsApplyShowStatus = 'PENDING'
    private platforms = []
    private bugList = []
    private curTab = 'detail'
    private mediaType: any = ''
    private loading = false
    private bugDialogVisible = false
    private isRecommend = false
    private delete_news_apply_status = ''
    private created() {
        const isRecommend = this.$route.query.recommend
        if (isRecommend) this.isRecommend = true
    }

    private mounted() {
        this.$title('Loading | 新闻详情 - 庖丁')
        this.newsId = parseInt(this.$route.params.id)
        this.mediaType = this.$route.query.mtype || undefined
        this.loading = true
        this.getDetail()
        this.getBugList()
        this.getDeleteNewsApplyStatus()
    }

    private async getDetail() {
        const result = await NewsService.getDetail({ id: this.newsId, media_type: this.mediaType })
        if (result.status === 200) {
            this.$title(`${result.data.title} | 新闻详情 - 庖丁`)
            this.news = this.filterNews(result.data)
        }
        this.loading = false
    }

    private async getBugList() {
        const params = { news_id: this.newsId, status: this.bugStatusMap.toFixed, media_type: this.mediaType }
        const result = await BugService.getList(params)
        if (result.status === 200) {
            this.bugList = result.data.bug_list
        }
    }

    private async getDeleteNewsApplyStatus(){
        const params = { news_id: this.newsId }
        const result = await UserService.getDeleteNewApply(params)
        if (result.status === 200) {
            this.delete_news_apply_status = result.data.status
        }
    }

    // 获取各个平台数据
    private async getPlatforms() {
        const result = await NewsService.getPlatforms({ news_id: this.newsId, media_type: this.mediaType })
        if (result.status === 200) {
            this.platforms = this.filterPlatforms(result.data)
        }
    }

    // 计算新闻的元数据的比例
    private filterNews(news: any) {
        news.com_read_ratio = this.calcRatio(news.comment_total_count, news.read_total_count)
        news.like_read_ratio = this.calcRatio(news.like_total_count, news.read_total_count)
        news.share_read_ratio = this.calcRatio(news.share_total_count, news.read_total_count)
        news.int_read_ratio = this.calcRatio(news.interact_total_count, news.read_total_count)
        return news
    }

    // 计算新闻在各个平台的元数据的比例
    private filterPlatforms(platforms: any) {
        platforms = platforms.map((platform: any) => {
            platform.com_read_ratio = this.calcRatio(platform.comment_count, platform.read_count)
            platform.like_read_ratio = this.calcRatio(platform.like_count, platform.read_count)
            platform.share_read_ratio = this.calcRatio(platform.share_count, platform.read_count)
            platform.int_read_ratio = this.calcRatio(platform.interact_count, platform.read_count)
            return platform
        })
        return platforms
    }

    // 计算和阅读数的比例，以 1 为最小公倍数
    private calcRatio(targetCount: number, readCount: number) {
        if (readCount !== 0 && targetCount !== 0) {
            return '1/' + Math.round(readCount / targetCount)
        }
        if (readCount === 0 && targetCount === 0) {
            return '0/0'
        }
        if (readCount !== 0 && targetCount === 0) {
            return '0/' + readCount
        }
        if (readCount === 0 && targetCount !== 0) {
            return targetCount + '/0'
        }
    }

    private bugTypeMap(type: number) {
        for (let index in this.bugTypeOptions) {
            if (this.bugTypeOptions[index].key === type) {
                return this.bugTypeOptions[index].value
            }
        }
    }

    private formatNumber(num: number | undefined): string {
        if (!num || num === 0) return '0'
        if (num >= 10000) {
            return (num / 10000).toFixed(1) + '万'
        }
        return num.toString()
    }

    private updateRemarksCb() {}

    private onEditBugRemarks(bug: any) {
        (this.$refs.editRemarks as any).show(bug, () => {
            this.getBugList()
        })
    }

    private onSwitchTab(tab: any) {
        this.curTab = tab.name
        if (this.curTab === 'platform') {
            this.getPlatforms()
        }
    }

    private onAddBug() {
        this.bugDialogVisible = true
    }

    private onHideBugDialog() {
        this.bugDialogVisible = false
    }

    private onGoOrigin(news: INewsData) {
        window.open(news.origin_url)
    }

    private onGoNiumei(news: INewsData) {
        if (location.host === 'pd.media.beer') {
            window.open(NIUMEI_HOST + 'news/' + news.id + `?type=${news.data_type}&mtype=${this.$route.query.mtype}`)
        } else {
            window.open(NIUMEI_TEST_HOST + 'news/' + news.id + `?type=${news.data_type}&mtype=${this.$route.query.mtype}`)
        }
    }

    private onEdit(news: INewsData) {
        const mType = this.$route.query.mtype || ''
        window.open('/news/' + news.id + '/edit' + `?mtype=${mType}`)
    }

    private onRemove(news: INewsData) {
        this.$confirm('确认把这篇文章设为删除态？删除态的文章牛媒内不显示', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            const params = { id: news.id, is_deleted: true, media_type: this.$route.query.mtype || undefined }
            const result = await NewsService.updateNews(params)
            if (result.status === 419) {
                this.createDeleteNewsApply(news)
                return
            }

            if (result.status !== 200) {
                this.$message({
                    type: 'error',
                    message: '设置失败，请重试'
                })
                return
            }
            this.news.is_deleted = true
            this.$message({
                type: 'success',
                message: '已设置为删除状态，牛媒内无法浏览'
            })

        }).catch(() => {})
    }

    private async createDeleteNewsApply(news: INewsData) {
        this.$confirm('权限不足，是否提交删除申请', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            const result = await UserService.postDeleteNewApply({ news_id: news.id, status: this.deletedNewsApplyShowStatus })
            if (result.status === 200) {
                this.delete_news_apply_status = this.deletedNewsApplyShowStatus
                this.$message({
                    type: 'success',
                    message: '申请提交成功'
                })
            } else {
                this.$message({
                    type: 'error',
                    message: '申请提交失败'
                })
            }
        }).catch(() => {})
    }

    private onRestore(news: INewsData) {
        this.$confirm('目前这篇文章是删除态，是否确认还原为正常状态？此操作有风险，请谨慎操作', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            const params = { id: news.id, is_deleted: false, media_type: this.$route.query.mtype || undefined }
            const result = await NewsService.updateNews(params)
            if (result.status === 200) {
                this.news.is_deleted = false
                this.$message({
                    type: 'success',
                    message: '已还原为正常状态，牛媒内可以浏览'
                })
            }
        }).catch(() => {})
    }

    private onRecommend(news: any) {
        this.$confirm('将推荐该新闻到牛媒首页, 是否确定?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            recommendNews({
                id: news.id,
                sucessFn: () => {
                    this.$message({
                        type: 'success',
                        message: '推荐成功',
                        showClose: true
                    })
                },
                failFn: result => {
                    this.$message({
                        type: 'success',
                        message: result.message || '发生错误，推荐失败',
                        showClose: true
                    })
                }
            })
        })
    }
}
